<template>
  <a-sub-menu title="子菜单">
    <span slot="title">
      <span>劳动人事部</span>
    </span>
    <template v-for="(item, index) in list">
      <a-menu-item v-if="!item.children" :key="item.title">
        <span>{{ item.title }}</span>
      </a-menu-item>
      <tree-menus :key="index" v-else :list="item.children"></tree-menus>
    </template>
  </a-sub-menu>
</template>

<script>
export default {
  name: "treeMenus",
  props: {
    list: Array
  },
  data() {
    return {};
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/system/components/tree-menus.vue